import React, { useEffect } from "react";
import LineTime from "../components/LineTime";
import { 
  cedulaEsp, 
  Daniel, 
  diploma, 
  diplomaInst, 
  titulo, 
  tituloDoc 
} from "../resources";
import "../pages/SobreMi.css";
import ImageButton from "../components/imagebutton";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles.css";
import CofeprisAdGallery from "../components/CofeprisAd";
import '../pages/Home.css';
function SobreMi() {

  // Inicializa animaciones al hacer scroll
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // Educación profesional
  const profesional = [
    { year: "2005-2011", title: "Médico cirujano", description: "Facultad de Medicína y Cirugía, Universidad Autónoma Benito Juárez de Oaxaca." },
    { year: "2010-2011", title: "Internado de pregrado", description: "Hospital General 'Dr. Aurelio Valdivieso' Secretaría de Salubridad y Asistencia." },
    { year: "2011-2012", title: "Servicio Social", description: "Unidad Médica Rural No.217 I.M.S.S, San Sebastián Teitipac, Tlacolula, Oax." },
    { year: "2012", title: "Examen teórico profesional", description: "Universidad Autónoma Benito Juárez de Oaxaca." },
    { year: "2012", title: "Examen práctico profesional", description: "Universidad Autónoma Benito Juárez de Oaxaca." },
    { year: "2015-2019", title: "Residencia médica en la especialidad de ginecología y obstetricia", description: "Hospital General 'Dr. Aurelio Valdivieso' Secretaría de Salubridad y Asistencia." }
  ];

  // Cursos de pregrado
  const cursosPregrado = [
    { year: "22-24 Noviembre 2007", title: "Actualizaciones médico quirúrgicas", description: "Facultad de Medicína y Cirugía, UABJO." },
    { year: "Nov 2006 - Ene 2007", title: "Educación integral en desarrollo humano", description: "Centro Evaluador de Calidad Empresarial." },
    { year: "6-8 Marzo 2008", title: "Taller de imagenología TAC y RM en SNC", description: "Facultad de Medicína y Cirugía, UABJO." },
    { year: "30-31 Mayo 2008", title: "III Congreso regional de medicina interna", description: "Colegio de Medicina Interna de México." },
    { year: "27-28 Marzo 2009", title: "Primeras jornadas del colegio oaxaqueño de ginecología y obstetricia", description: "Colegio Oaxaqueño de Ginecología y Obstetricia." },
    { year: "7-8 Junio 2013", title: "Curso precongreso 'Mortalidad materna perspectiva sur'", description: "Colegio Oaxaqueño de Ginecología y Obstetricia." },
    { year: "6 Junio 2013", title: "XXI Congreso regional de ginecología y obstetricia", description: "Colegio Oaxaqueño de Ginecología y Obstetricia." },
    { year: "27-29 Junio 2013", title: "XV Congreso estatal de pediatría y simposio de neonatología", description: "Colegio de Pediatría del Estado de Oaxaca." },
    { year: "5 Febrero - 29 Agosto 2013", title: "Curso ENARM", description: "Colegio LaSalle Oaxaca." },
    { year: "12-14 Junio 2014", title: "XVI Congreso estatal de pediatría", description: "Colegio de Pediatría del Estado de Oaxaca." },
    { year: "16-18 Octubre 2014", title: "Curso de urgencias y patología en obstetricia y ginecología", description: "Sistema de educación continua para el médico general." }
  ];

  // Posgrado
  const posgrado = [
    { year: "Marzo - Octubre 2019", title: "Diplomado de colposcopia", description: "Hospital General 'Dr. Aurelio Valdivieso' Secretaría de Salud." }
  ];

  return (
    <div className="sobre-mi-container">
      
      <div className="floating-buttons-container">
                 <div className="floating-megafono"> <CofeprisAdGallery /></div>
                <div className="watermark-floating"></div>
                <FloatingWhatsApp
                className="floating-whatsapp"
                  phoneNumber="5219511035059"
                  avatar={Daniel}
                  accountName="Dr. Daniel Sánchez Sarabia"
                  chatMessage="¡Hola! ¿En qué puedo ayudarte?"
                  placeholder="Escribe tu mensaje..."
                  darkMode={false}
                />
            </div>

      {/* Sección de diplomas */}
      <div className="image-buttons-container" data-aos="fade-up">
        <ImageButton buttonName="Título profesional" image={tituloDoc} alt="Título profesional del Dr. Daniel Sánchez Sarabia" />
        <ImageButton buttonName="Título de especialidad" image={titulo} alt="Título de especialidad en Ginecología y Obstetricia" />
        <ImageButton buttonName="Cédula de especialidad" image={cedulaEsp} alt="Cédula de especialidad médica" />
        <ImageButton buttonName="Diplomado de Ginecología" image={diplomaInst} alt="Diplomado de Ginecología" />
        <ImageButton buttonName="Diplomado de Colposcopia" image={diploma} alt="Diplomado de Colposcopia" />
      </div>

      {/* Educación profesional */}
      <div data-aos="fade-up">
        <LineTime title="Educación profesional" events={profesional} />
      </div>

      {/* Cursos */}
      <div data-aos="fade-up" data-aos-delay="150">
        <LineTime title="Cursos de pregrado" events={cursosPregrado} />
      </div>

      {/* Posgrado */}
      <div data-aos="fade-up" data-aos-delay="300">
        <LineTime title="Posgrado" events={posgrado} />
      </div>
    </div>
  );
}

export default SobreMi;
